var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.links),function(link){return _c('a',{key:link.linkName,staticStyle:{"display":"block","text-decoration":"underline"},attrs:{"href":link.url,"target":"_blank"}},[_vm._v("\n    "+_vm._s(link.linkName)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }